import { uid } from '../../../../lib/uid';

/**
 * Test data backing the Autogenerate button on the eligibility form.
 *
 * Fills the one required field so the primary action enables on the first try. Keep it in
 * lockstep with the form: a new required field must be added here in the same change, or
 * Autogenerate silently stops working.
 *
 * Values are synthetic. The names below are generic civil-service vocabulary, not a real
 * organization's list copied from production — a generated record is written to the database.
 */

const ELIGIBILITIES = [
  'Career Service (Professional)',
  'Career Service (Sub-Professional)',
  'Board Licence',
  'Bar Licence',
  'Driver Licence',
  'Fire Officer Examination',
  'Barangay Health Worker',
];

/**
 * One eligibility.
 *
 * The name carries a suffix because it is unique among the ACTIVE rows, and Autogenerate is
 * most useful clicked repeatedly — without one the second click would produce a name the
 * server rejects as a duplicate. The description is left alone: it is optional, so filling it
 * would put words on the record that nobody wrote.
 */
export function sampleEligibility(): { name: string } {
  const pick = ELIGIBILITIES[Math.floor(Math.random() * ELIGIBILITIES.length)];
  return { name: `${pick} ${uid().slice(0, 6).toLowerCase()}` };
}
